import { useState } from 'react';
import { RadioGroup, Radio } from '@heroui/react';

type Option = {
  value: string;
  label: string;
  description?: string;
};

type SelectableRadioGroupProps = {
  options: Option[];
  value: string;
  label: string;
  onChange?: (value: string) => void;
};

export default function SelectableRadioGroup({
  options,
  value,
  label,
  onChange,
}: SelectableRadioGroupProps) {
  const [selectedValue, setSelectedValue] = useState<string>(value);

  const handleChange = (value: string) => {
    setSelectedValue(value);
    if (onChange) {
      onChange(value);
    }
  };
  return (
    <RadioGroup
      label={label}
      value={selectedValue}
      onValueChange={handleChange}
      classNames={{
        label: 'font-semibold text-sm',
      }}
    >
      {options.map(({ value, label, description }) => (
        <Radio
          key={value}
          value={value}
          disableAnimation
          classNames={{
            control: 'group-data-[selected=true]:bg-[#fff]',
            wrapper:
              ' group-data-[selected=true]:border-6 group-data-[selected=true]:border-primary-500 group-data-[selected=true]:rounded-[16px]',
            base: 'text-sm gap-2',
            label: description ? 'flex flex-col' : ''
          }}
        >
          <span className='text-sm'>{label}</span>
          {description && (
            <span className="text-xs text-default-500 font-normal">{description}</span>
          )}
        </Radio>
      ))}
    </RadioGroup>
  );
}
